import * as React from 'react';
import {useState} from "react";
import {Input, Row, Col, Form, Select} from 'antd';
import {FormattedMessage, injectIntl} from 'react-intl';
import {SelectionMode} from "@models/index";
import {AliasTypeOptions} from "@models/alias";
import Search, {SearchInputType} from "@components/custom/Search";
import {AliasType} from "@models/alias";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SearchAliasComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  const [referenceType, setReferenceType] = useState(null);
  
  const onChangeValues = (filter) => {
    setReferenceType(filter.type)
  };
  
  
  const getSearchInputs = () =>{
    const defaultFields = [{
      name: "query",
      label: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      type: SearchInputType.TEXT,
      size: 8
    }, {
      name: "type",
      label: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
      type: SearchInputType.SELECT,
      options: AliasTypeOptions,
      size: 8
    }];
    
    if(referenceType){
      return [
        ...defaultFields,{
          name: "reference_id",
          label: <FormattedMessage id="app.reference" defaultMessage={`Reference`}/>,
          type: referenceType == AliasType.PERSON ? SearchInputType.PERSON : AliasType.ROLE,
          size: 8
        }
      ]
    }
    else{
      return defaultFields;
    }
    
  };
  
  
  return <Search inputs={getSearchInputs()}
                 onChangeFilter={onChangeValues}
                 search={search}/>
  
};

export default SearchAliasComponent;